export enum EventFormCustomFormType {
  common = "0",
  Product = "2",
  Donation = "3",
  NestProduct = "4",
  Michlol = "10",
  DmeyHaver = "500",
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/event-page-models/event-form-custom-form-type.ts